import { RegisterExpressionRules } from "./Expressions/RegisterExpressionRules";
import { RegisterFlowStepDatas } from "./Flow/Utilities/RegisterFlowStepDatas";
import { RegisterFlowStepRunners } from "./Flow/Utilities/RegisterFlowStepRunners";
import { ExpressionValue } from "./Expressions/ExpressionValue";
import { MappingConfiguration } from "./Mapping/MappingConfiguration";
import { RegisterTextElements } from "./TextMerge/RegisterTextElements";
import { TextMergeConfiguration } from "./TextMerge/TextMergeConfiguration";

export class AppGlueCommonInit {
    static wasInit = false;

    static init() {
        if (this.wasInit) return;
        this.wasInit = true;

        // register flow step data
        RegisterFlowStepDatas.doRegistration();
        RegisterFlowStepRunners.doRegistration();

        // register rules
        RegisterExpressionRules.doRegistration();

        RegisterTextElements.doRegistration();

        // register prototypes
        ExpressionValue.mergePrototype = Object.getPrototypeOf(new TextMergeConfiguration());

        ExpressionValue.mappingPrototype = Object.getPrototypeOf(new MappingConfiguration());
    }
}
